import { render } from "./SetCard.vue?vue&type=template&id=d77699f2&scoped=true"
import script from "./SetCard.vue?vue&type=script&lang=js"
export * from "./SetCard.vue?vue&type=script&lang=js"

import "./SetCard.vue?vue&type=style&index=0&id=d77699f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d77699f2"]])

export default __exports__